import { useState } from "react";

export type ViewMode = "list" | "card";

/**
 * List/card view state for a directory page, persisted to localStorage so the
 * choice survives navigation and reload. Each page passes a distinct
 * `storageKey` (e.g. "persons.view") so the pages don't share one setting.
 */
export function useViewMode(storageKey: string): [ViewMode, (next: ViewMode) => void] {
  const [view, setViewState] = useState<ViewMode>(() =>
    typeof window !== "undefined" && window.localStorage.getItem(storageKey) === "card"
      ? "card"
      : "list",
  );
  const setView = (next: ViewMode) => {
    setViewState(next);
    if (typeof window !== "undefined") window.localStorage.setItem(storageKey, next);
  };
  return [view, setView];
}
